import { useEffect } from "react";

const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.maamaas.app";

const IOS_URL =
  "https://apps.apple.com/in/app/maamaas/id6759244693";

const WEBSITE_URL =
  "https://www.maamaas.com";

function Download() {
  useEffect(() => {
    const userAgent =
      navigator.userAgent || navigator.vendor || window.opera;

    // Android
    if (/android/i.test(userAgent)) {
      window.location.replace(ANDROID_URL);
      return;
    }

    // iPhone / iPad / iPod
    if (/iPhone|iPad|iPod/i.test(userAgent)) {
      window.location.replace(IOS_URL);
      return;
    }

    // Desktop / Other
    window.location.replace(WEBSITE_URL);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <h2>Opening Maamaas...</h2>
      <p>Please wait...</p>
    </div>
  );
}

export default Download;